import {
	Directive,
	OnInit,
	ElementRef,
	HostListener,
	Renderer2,
	Input
} from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { environment } from '@onviobr/services';
enum CurrencyCode {
	US = 'USD'
}
@Directive({
	selector: '[appCurrency]',
})
export class CurrencyDirective implements OnInit {
	@Input() currencyFormat = '1.2-2';
	currencyCode: string;
	constructor(
		public el: ElementRef,
		public renderer: Renderer2,
		private currencyPipe: CurrencyPipe
	) {}
	ngOnInit() {
		environment.getEnvironmentAsync().then((s) => {
			this.currencyCode = CurrencyCode[s.countryCode];
			this.format(this.el.nativeElement.value);
		});
	}
	@HostListener('blur', ['$event.target.value']) onInput(e: string) {
		this.format(e);
	}
	@HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
		event.preventDefault();
		this.format(event.clipboardData.getData('text/plain'));
	}
	format(val: string) {
		const curValue = val || 0;
		const currencyValue = this.currencyPipe.transform(
			curValue.toString().replace(/[^0-9\.]+/g, ''),
			this.currencyCode,
			'symbol',
			this.currencyFormat
		);
		this.renderer.setProperty(this.el.nativeElement, 'value', currencyValue);
	}
}
